/* NORTHSTAR mobile-only homepage interactions.
 * Every interaction is guarded by the 749px mobile media query.
 */
(() => {
    const mq = window.matchMedia('(max-width: 749px)');
    const normalizeProductPriceRanges = () => {
      document.querySelectorAll('.tr-featured-grid .price').forEach((price) => {
        if (price.dataset.trPriceRangeNormalized === 'true') return;
        const target = price.querySelector('.price-item--regular, .price-item--sale, .price-item');
        if (!target) return;
        const text = target.textContent.trim();
        const match = text.match(/^([^\d]*\d[\d,.]*)\s*[\u2013-]\s*[^\d]*\d[\d,.]*/);
        if (!match) return;
        target.textContent = match[1].trim();
        price.dataset.trPriceRangeNormalized = 'true';
      });
    };

    const setup = () => {
      normalizeProductPriceRanges();
      document.querySelectorAll('.thirdreality-home-lower__review-track').forEach((track) => {
        if (track.dataset.trReviewEnhanced === 'true') return;
        const cards = Array.from(track.querySelectorAll('.thirdreality-home-lower__review-card'));
        if (cards.length < 2) return;
        let index = cards.findIndex((card) => card.classList.contains('is-tr-mobile-active'));
        if (index < 0) index = 0;

        const show = (next) => {
          const previous = index;
          index = (next + cards.length) % cards.length;
          if (previous === index) return;
          cards[previous].classList.add('is-tr-mobile-leaving');
          cards[previous].classList.remove('is-tr-mobile-active');
          setTimeout(() => {
            cards[previous].classList.remove('is-tr-mobile-leaving');
            cards[index].classList.add('is-tr-mobile-active');
          }, 360);
        };

        track.dataset.trReviewEnhanced = 'true';
        track.addEventListener('click', (event) => {
          if (!mq.matches) return;
          event.preventDefault();
          event.stopPropagation();
          show(index + 1);
        }, true);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }

    document.addEventListener('shopify:section:load', setup);
  })();

(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const supportLabels = ['One-Year Warranty', 'Firmware & OTA Updates', 'YouTube Video Demos'];
  const syncSupportLabels = () => {
    document.querySelectorAll('.thirdreality-home-lower__support-card h3').forEach((heading, index) => {
      if (!heading.dataset.trDesktopLabel) heading.dataset.trDesktopLabel = heading.textContent.trim();
      heading.textContent = mq.matches
        ? (supportLabels[index] || heading.dataset.trDesktopLabel)
        : heading.dataset.trDesktopLabel;
    });
  };

  const setup = () => {
    syncSupportLabels();
    document.querySelectorAll('.thirdreality-home-lower__review-track').forEach((track) => {
      if (track.dataset.trMobileTapReady === 'true') return;
      const cards = Array.from(track.querySelectorAll('.thirdreality-home-lower__review-card'));
      if (!cards.length) return;
      let index = 0;
      const show = (next) => {
        index = (next + cards.length) % cards.length;
        cards.forEach((card, cardIndex) => card.classList.toggle('is-tr-mobile-active', cardIndex === index));
      };
      track.dataset.trMobileTapReady = 'true';
      track.setAttribute('tabindex', '0');
      track.setAttribute('aria-label', 'Customer reviews');
      show(0);
      track.addEventListener('click', () => { if (mq.matches) show(index + 1); });
      track.addEventListener('keydown', (event) => {
        if (!mq.matches) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          show(index + 1);
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  mq.addEventListener('change', syncSupportLabels);
  document.addEventListener('shopify:section:load', setup);
})();
